module.exports = __webpack_public_path__ + "img/icon-freefire.b487583.png";